// extracted by mini-css-extract-plugin
export default {"root":"EgzI6j7JUDk2_vEPpiOo","dag":"gKUp_QYM_iYOu1t3LWso"};